/*********************** Custom JS for Boost AI Search & Discovery  ************************/
(function() {
  'use strict';

  var SEARCH_INPUT_SELECTOR = '.boost-sd__search-widget-init-input, form.search-form input[name="q"]';
  var PLACEHOLDER_TEXT = null;
  var PLACEHOLDER_OBSERVERS = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var PRODUCT_ITEM_SELECTOR = '.boost-sd__product-item, .boost-sd__search-result-item, .boost-sd__suggestion-queries-item--product, [data-product][data-product-id]';
  var IMAGE_WRAPPER_SELECTORS = [
    '.boost-sd__product-image-wrapper',
    '.boost-sd__product-item-grid-view-layout-image',
    '.boost-sd__product-link-image',
    '.boost-sd__search-result-item-image',
    '.boost-sd__search-result-item-media',
    '.boost-sd__search-result-item-media-wrapper'
  ];
  var THEME_STICKER_ATTRIBUTE = 'data-theme-sticker';
  var BADGE_BATCH_SIZE = 10;
  var badgeDataCache = {};
  var badgeDataInflight = {};
  var htmlDecoder = typeof document !== 'undefined' ? document.createElement('textarea') : null;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function getPlaceholderText() {
    if (PLACEHOLDER_TEXT !== null) {
      return PLACEHOLDER_TEXT;
    }
    var body = document.body;
    var fallback = 'SEARCH';
    if (body && body.dataset && body.dataset.searchPlaceholder) {
      PLACEHOLDER_TEXT = body.dataset.searchPlaceholder;
      return PLACEHOLDER_TEXT;
    }
    PLACEHOLDER_TEXT = fallback;
    return PLACEHOLDER_TEXT;
  }

  function applyPlaceholder(input) {
    if (!input || !input.setAttribute) {
      return;
    }
    var text = getPlaceholderText();
    if (!text) {
      return;
    }
    if (input.getAttribute('placeholder') !== text) {
      input.setAttribute('placeholder', text);
    }
    if (input.getAttribute('aria-label') !== text) {
      input.setAttribute('aria-label', text);
    }
    if (input.hasAttribute('data-placeholder') && input.getAttribute('data-placeholder') !== text) {
      input.setAttribute('data-placeholder', text);
    }
  }

  function bindPlaceholderObserver(input) {
    if (!input || typeof MutationObserver === 'undefined' || (PLACEHOLDER_OBSERVERS && PLACEHOLDER_OBSERVERS.has(input))) {
      return;
    }
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].attributeName === 'placeholder') {
          // applyPlaceholder(input);
          return;
        }
      }
    });
    observer.observe(input, { attributes: true, attributeFilter: ['placeholder'] });
    if (PLACEHOLDER_OBSERVERS) {
      PLACEHOLDER_OBSERVERS.set(input, observer);
    }
  }

  function matchesSelector(el, selector) {
    if (!el || el.nodeType !== 1) {
      return false;
    }
    var proto = Element.prototype;
    var matchFn = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;
    if (!matchFn) {
      return false;
    }
    return matchFn.call(el, selector);
  }

  function handleSearchInput(input) {
    if (!input) {
      return;
    }
    // applyPlaceholder(input);
    bindPlaceholderObserver(input);
  }

  function scanForSearchInputs(root) {
    if (!root) {
      return;
    }
    if (matchesSelector(root, SEARCH_INPUT_SELECTOR)) {
      handleSearchInput(root);
    }
    if (root.querySelectorAll) {
      var nodes = root.querySelectorAll(SEARCH_INPUT_SELECTOR);
      for (var i = 0; i < nodes.length; i += 1) {
        handleSearchInput(nodes[i]);
      }
    }
  }

  function startSearchInputObserver() {
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) {
          for (var j = 0; j < mutation.addedNodes.length; j += 1) {
            var node = mutation.addedNodes[j];
            if (node.nodeType === 1) {
              scanForSearchInputs(node);
            }
          }
        }
      }
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  function hasBoostSearchClass(el) {
    if (!el || typeof el.className !== 'string') {
      return false;
    }
    return el.className.indexOf('boost-sd__search') !== -1;
  }

  function clearInlineScrollLock(el) {
    if (!el || !el.style) {
      return;
    }
    if (el.style.overflow) {
      el.style.overflow = '';
    }
    if (el.style.position === 'fixed') {
      el.style.position = '';
    }
    if (el.style.height && el.style.height !== '') {
      el.style.height = '';
    }
    if (el.style.paddingRight && el.style.paddingRight !== '') {
      el.style.paddingRight = '';
    }
  }

  function setScrollUnlockState(isUnlocked) {
    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) {
      return;
    }
    if (isUnlocked) {
      body.setAttribute('data-boost-sd-scroll-unlocked', 'true');
      html.setAttribute('data-boost-sd-scroll-unlocked', 'true');
    } else {
      body.removeAttribute('data-boost-sd-scroll-unlocked');
      html.removeAttribute('data-boost-sd-scroll-unlocked');
    }
  }

  function evaluateScrollLock() {
    var body = document.body;
    var html = document.documentElement;
    if (!body || !html || typeof window.getComputedStyle === 'undefined') {
      return;
    }
    var boostActive = hasBoostSearchClass(body) || hasBoostSearchClass(html);
    if (!boostActive) {
      setScrollUnlockState(false);
      return;
    }
    scanForSearchInputs(document);
    var bodyLocked = window.getComputedStyle(body).overflow === 'hidden';
    var htmlLocked = window.getComputedStyle(html).overflow === 'hidden';
    var shouldUnlock = bodyLocked || htmlLocked;
    if (shouldUnlock) {
      clearInlineScrollLock(body);
      clearInlineScrollLock(html);
      setScrollUnlockState(true);
    } else {
      setScrollUnlockState(false);
    }
  }

  function startScrollObserver() {
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type === 'attributes' && (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
          evaluateScrollLock();
          return;
        }
      }
    });
    observer.observe(document.body || document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  function bindGlobalEvents() {
    document.addEventListener('focusin', function(event) {
      var target = event.target;
      if (matchesSelector(target, SEARCH_INPUT_SELECTOR)) {
        handleSearchInput(target);
        evaluateScrollLock();
      }
    });

    document.addEventListener('shopify:section:load', function(event) {
      scanForSearchInputs(event && event.target ? event.target : document);
      evaluateScrollLock();
      scanForProductItems(event && event.target ? event.target : document);
    });
  }

  function getThemeSettings() {
    return (window.PXUTheme && window.PXUTheme.theme_settings) ? window.PXUTheme.theme_settings : {};
  }

  function parsePositiveInteger(value, fallback) {
    var parsedValue = typeof value === 'number' ? value : parseInt(value, 10);
    if (isNaN(parsedValue) || parsedValue < 1) {
      return fallback;
    }
    return parsedValue;
  }

  function getNewArrivalWindowDays() {
    return 90;
  }

  function getAlmostGoneThreshold() {
    var themeSettings = getThemeSettings();
    return parsePositiveInteger(themeSettings.sticker_almost_gone_threshold, 3);
  }

  function getThemeTranslations() {
    return (window.PXUTheme && window.PXUTheme.translation) ? window.PXUTheme.translation : {};
  }

  function decodeHtmlEntities(value) {
    if (!value || !htmlDecoder) {
      return value || '';
    }
    htmlDecoder.innerHTML = value;
    return htmlDecoder.value;
  }

  function handleize(value) {
    if (typeof value !== 'string') {
      return '';
    }
    return value.toLowerCase()
      .replace(/[\s_]+/g, '-')
      .replace(/[^a-z0-9\-]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function toArray(value) {
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === 'string') {
      var trimmed = value.trim();
      if (!trimmed) {
        return [];
      }
      if (trimmed[0] === '[' || trimmed[0] === '{' || trimmed[0] === '"') {
        try {
          var parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return parsed;
          }
        } catch (err) {
          return [];
        }
      }
      if (trimmed.indexOf(',') !== -1) {
        return trimmed.split(',').map(function(part) {
          return part.trim();
        });
      }
      return [trimmed];
    }
    return [];
  }

  function parseProductData(node) {
    if (!node) {
      return null;
    }
    var raw = node.getAttribute('data-product');
    if (!raw) {
      return null;
    }
    var decoded = decodeHtmlEntities(raw);
    if (!decoded) {
      return null;
    }
    try {
      return JSON.parse(decoded);
    } catch (error) {
      return null;
    }
  }

  function getNormalizedHandle(handle) {
    if (!handle) {
      return '';
    }
    return handleize(handle);
  }

  function getBadgeDataByHandle(handle) {
    var normalized = getNormalizedHandle(handle);
    if (!normalized) {
      return null;
    }
    if (Object.prototype.hasOwnProperty.call(badgeDataCache, normalized)) {
      return badgeDataCache[normalized];
    }
    return null;
  }

  function storeBadgeData(payload) {
    if (!payload) {
      return;
    }
    for (var key in payload) {
      if (!Object.prototype.hasOwnProperty.call(payload, key)) {
        continue;
      }
      var normalized = getNormalizedHandle(key);
      if (!normalized) {
        continue;
      }
      var entry = payload[key] || {};
      var existing = badgeDataCache[normalized] || {};

      // Merge new data with existing, preferring non-null values
      var newEntry = {
        published_at: entry.published_at || entry.created_at || existing.published_at || null,
        created_at: entry.created_at || existing.created_at || null,
        total_inventory: null,
        available: null
      };

      // For inventory, prefer defined values over null
      if (typeof entry.total_inventory === 'number') {
        newEntry.total_inventory = entry.total_inventory;
      } else if (entry.total_inventory !== null && typeof entry.total_inventory !== 'undefined') {
        var parsed = parseInt(entry.total_inventory, 10);
        if (!isNaN(parsed)) {
          newEntry.total_inventory = parsed;
        }
      }
      // Fall back to existing if new is null
      if (newEntry.total_inventory === null && existing.total_inventory !== null && typeof existing.total_inventory !== 'undefined') {
        newEntry.total_inventory = existing.total_inventory;
      }

      // For available, prefer defined values
      if (typeof entry.available === 'boolean') {
        newEntry.available = entry.available;
      } else if (typeof existing.available === 'boolean') {
        newEntry.available = existing.available;
      }

      badgeDataCache[normalized] = newEntry;
      delete badgeDataInflight[normalized];
    }
  }

  function loadEmbeddedInventoryData() {
    var scriptEl = document.getElementById('boost-inventory-data');
    if (!scriptEl) {
      console.debug('[BadgeData] No embedded inventory data found on page');
      return false;
    }
    try {
      var data = JSON.parse(scriptEl.textContent);
      if (data && typeof data === 'object') {
        var keys = Object.keys(data);
        console.log('[BadgeData] Found embedded inventory data:', keys.length, 'products');
        // Log sample of data for debugging
        if (keys.length > 0) {
          var sampleKey = keys[0];
          console.debug('[BadgeData] Sample entry:', sampleKey, data[sampleKey]);
        }
        storeBadgeData(data);
        return true;
      }
    } catch (e) {
      console.warn('[BadgeData] Failed to parse embedded inventory data', e);
    }
    return false;
  }

  function fetchSingleProductJson(handle) {
    // Fetch the product page HTML to get the embedded JSON with inventory data
    var url = '/products/' + encodeURIComponent(handle);
    return fetch(url, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) {
          console.warn('[BadgeData] Product page failed for', handle, response.status);
          return null;
        }
        return response.text();
      })
      .then(function(html) {
        if (!html) {
          return null;
        }

        var result = {
          handle: handle,
          published_at: null,
          created_at: null,
          total_inventory: null, // null means "unknown" - don't override with 0
          available: null // null means "unknown"
        };

        // First, try to find the product-inventory-data script tag (our custom embedded data)
        var inventoryDataMatch = html.match(/<script[^>]*id="product-inventory-data"[^>]*>([\s\S]*?)<\/script>/i);
        if (inventoryDataMatch && inventoryDataMatch[1]) {
          try {
            var inventoryData = JSON.parse(inventoryDataMatch[1].trim());
            if (inventoryData) {
              result.published_at = inventoryData.published_at || null;
              result.created_at = inventoryData.created_at || null;
              result.total_inventory = typeof inventoryData.total_inventory === 'number' ? inventoryData.total_inventory : null;
              result.available = typeof inventoryData.available === 'boolean' ? inventoryData.available : null;
              console.log('[BadgeData] Found product-inventory-data for', handle, {
                totalInventory: result.total_inventory,
                available: result.available
              });
              return result;
            }
          } catch (e) {
            console.warn('[BadgeData] Failed to parse product-inventory-data for', handle, e);
          }
        }

        // Fallback: try to find the product JSON in the page using regex
        // Look for published_at in meta tags or JSON
        var publishedMatch = html.match(/"published_at"\s*:\s*"([^"]+)"/);
        if (publishedMatch) {
          result.published_at = publishedMatch[1];
        }

        var createdMatch = html.match(/"created_at"\s*:\s*"([^"]+)"/);
        if (createdMatch) {
          result.created_at = createdMatch[1];
        }

        // Look for inventory data - Shopify embeds this in a script tag
        // Pattern: "inventory_quantity":X or "available":true/false per variant
        var inventoryMatches = html.match(/"inventory_quantity"\s*:\s*(-?\d+)/g);

        if (inventoryMatches && inventoryMatches.length > 0) {
          var totalInventory = 0;
          for (var i = 0; i < inventoryMatches.length; i++) {
            var qtyMatch = inventoryMatches[i].match(/:?\s*(-?\d+)/);
            if (qtyMatch) {
              var qty = parseInt(qtyMatch[1], 10);
              if (!isNaN(qty)) {
                totalInventory += qty;
              }
            }
          }
          result.total_inventory = totalInventory;
          console.log('[BadgeData] Found inventory in HTML for', handle, ':', totalInventory);
        } else {
          // Could not find inventory in HTML - this is expected for some themes
          console.warn('[BadgeData] Could NOT find inventory in HTML for', handle, '- Almost Gone sticker may not work');
        }

        // Check if product is available
        var availableMatch = html.match(/"available"\s*:\s*(true|false)/);
        if (availableMatch) {
          result.available = availableMatch[1] === 'true';
        }

        console.log('[BadgeData] Parsed product page', handle, {
          totalInventory: result.total_inventory,
          available: result.available,
          published_at: result.published_at
        });

        return result;
      })
      .catch(function(err) {
        console.warn('[BadgeData] Fetch error for', handle, err);
        return null;
      });
  }

  function fetchBadgeDataBatch(handles) {
    if (!handles || !handles.length) {
      return Promise.resolve();
    }


    var fetchPromises = handles.map(function(handle) {
      return fetchSingleProductJson(handle);
    });

    return Promise.all(fetchPromises)
      .then(function(results) {
        var badgePayload = {};

        results.forEach(function(result) {
          if (result && result.handle) {
            badgePayload[result.handle] = {
              published_at: result.published_at,
              created_at: result.created_at,
              total_inventory: result.total_inventory,
              available: result.available
            };
          }
        });

        if (Object.keys(badgePayload).length > 0) {
          storeBadgeData(badgePayload);
        }
      })
      .catch(function(err) {
        console.error('[BadgeData] Batch fetch error', err);
        for (var i = 0; i < handles.length; i++) {
          var normalized = getNormalizedHandle(handles[i]);
          if (normalized && badgeDataInflight[normalized]) {
            delete badgeDataInflight[normalized];
          }
        }
      });
  }

  function fetchBadgeDataForHandles(handles) {
    if (!handles || !handles.length || typeof Promise === 'undefined') {
      return Promise.resolve();
    }
    var pending = [];
    for (var i = 0; i < handles.length; i += 1) {
      var normalized = getNormalizedHandle(handles[i]);
      if (!normalized) {
        continue;
      }
      if (typeof badgeDataCache[normalized] === 'undefined' && !badgeDataInflight[normalized]) {
        badgeDataInflight[normalized] = true;
        pending.push(normalized);
      }
    }
    if (!pending.length) {
      return Promise.resolve();
    }
    var batches = [];
    while (pending.length) {
      batches.push(pending.splice(0, BADGE_BATCH_SIZE));
    }
    var tasks = [];
    for (var j = 0; j < batches.length; j += 1) {
      console.debug('[BadgeData] Fetch batch', batches[j]);
      tasks.push(fetchBadgeDataBatch(batches[j]));
    }
    return Promise.all(tasks).then(function() {
      return badgeDataCache;
    });
  }

  function collectHandlesFromNodes(nodes) {
    var handles = [];
    if (!nodes || !nodes.length) {
      return handles;
    }
    for (var i = 0; i < nodes.length; i += 1) {
      var data = parseProductData(nodes[i]);
      if (data && data.handle) {
        var normalized = getNormalizedHandle(data.handle);
        if (normalized && handles.indexOf(normalized) === -1) {
          handles.push(normalized);
        }
      }
    }
    return handles;
  }

  function prefetchBadgeDataForNodes(nodes) {
    var handles = collectHandlesFromNodes(nodes);
    if (!handles.length) {
      return Promise.resolve();
    }
    console.debug('[BadgeData] Prefetch handles', handles);
    return fetchBadgeDataForHandles(handles);
  }

  function normalizeVariants(product) {
    var variants = product && product.variants ? product.variants : [];
    if (typeof variants === 'string') {
      var trimmed = variants.trim();
      if (trimmed) {
        try {
          variants = JSON.parse(trimmed);
        } catch (error) {
          variants = [];
        }
      }
    }
    return Array.isArray(variants) ? variants : [];
  }

  function buildLabelHandles(product) {
    var handles = [];
    var collections = toArray(product && product.collections ? product.collections : []);
    var tags = toArray(product && product.tags ? product.tags : []);
    if (!collections.length && product && product.productCollections) {
      collections = toArray(product.productCollections);
    }
    if (collections && collections.length) {
      collections.forEach(function(collection) {
        var handle = handleize(collection && collection.handle ? collection.handle : collection);
        if (handle && handles.indexOf(handle) === -1) {
          handles.push(handle);
        }
      });
    }
    if (tags && tags.length) {
      tags.forEach(function(tag) {
        var handle = handleize(tag);
        if (handle && handles.indexOf(handle) === -1) {
          handles.push(handle);
        }
      });
    }
    if (product && product.category) {
      var categoryHandle = handleize(product.category);
      if (categoryHandle && handles.indexOf(categoryHandle) === -1) {
        handles.push(categoryHandle);
      }
    }
    return handles;
  }

  function getStickerText(key, fallback) {
    var translations = getThemeTranslations();
    if (translations && (translations[key] || translations[key + '_sticker'])) {
      return translations[key] || translations[key + '_sticker'];
    }
    return fallback;
  }

  function isStickersEnabled() {
    var settings = getThemeSettings();
    return !!settings.stickers_enabled;
  }

  function hasBoostSoldOutLabel(node) {
    if (!node || !node.querySelector) {
      return false;
    }
    return !!node.querySelector('.boost-sd__product-label--soldout');
  }

  function parsePublishedDate(value) {
    if (value === null || typeof value === 'undefined') {
      return null;
    }
    if (value instanceof Date && !isNaN(value.getTime())) {
      return value;
    }
    var parsed = null;
    if (typeof value === 'number') {
      parsed = new Date(value > 9999999999 ? value : value * 1000);
    } else if (typeof value === 'string') {
      parsed = new Date(value);
      if (isNaN(parsed.getTime()) && value.indexOf('-') !== -1) {
        parsed = new Date(value.replace(/-/g, '/'));
      }
    }
    return parsed && !isNaN(parsed.getTime()) ? parsed : null;
  }

  function resolveCreatedAtSource(product) {
    if (!product) {
      return null;
    }
    var createdKeys = [
      'created_at',
      'createdAt',
      'created_date',
      'createdDate'
    ];
    for (var i = 0; i < createdKeys.length; i += 1) {
      var createdKey = createdKeys[i];
      if (product[createdKey]) {
        return product[createdKey];
      }
    }
    var publishedKeys = [
      'published_at',
      'publishedAt',
      'published_at_max',
      'publishedAtMax',
      'published_at_min',
      'publishedAtMin',
      'published_date',
      'publishedDate'
    ];
    for (var j = 0; j < publishedKeys.length; j += 1) {
      var key = publishedKeys[j];
      if (product[key]) {
        return product[key];
      }
    }
    if (product.updated_at) {
      return product.updated_at;
    }
    if (product.updatedAt) {
      return product.updatedAt;
    }
    return null;
  }

  function buildStickerMarkup(product, node) {
    if (!product || !isStickersEnabled()) {
      return '';
    }

    var handles = buildLabelHandles(product);
    var hasHandle = function(value) {
      return handles.indexOf(value) !== -1;
    };
    var badgeData = product && product.handle ? getBadgeDataByHandle(product.handle) : null;

    var variants = normalizeVariants(product);


    /* ===== LATEST CHANGE — Out of Stock label fix (availability logic) START ===== */
    // Per-variant availability from Boost's data-product JSON. This is the
    // LEAST reliable signal: Boost's search index can be stale and report
    // available:true for sold-out products (e.g. continue-selling variants),
    // so it is only used as a last resort below.
    var anyVariantAvailable = false;
    var sawVariantAvailability = false;
    for (var i = 0; i < variants.length; i += 1) {
      var variantAvailable = variants[i] && variants[i].available;
      if (typeof variantAvailable === 'undefined' || variantAvailable === null) {
        continue;
      }
      sawVariantAvailability = true;
      if (typeof variantAvailable === 'string') {
        variantAvailable = variantAvailable === 'true';
      }
      if (variantAvailable) {
        anyVariantAvailable = true;
        break;
      }
    }

    // Authoritative, server-rendered availability. badgeData.available comes
    // from boost-inventory-data.liquid (collection) or the product page's
    // product-inventory-data fetch (search); product.available is Boost's
    // own product-level flag. Either of these overrides the stale variant
    // flags so genuinely sold-out products get the "Sold Out" sticker.
    var badgeAvailable = badgeData && typeof badgeData.available === 'boolean' ? badgeData.available : null;
    var productAvailable = null;
    if (typeof product.available === 'boolean') {
      productAvailable = product.available;
    } else if (product.available === 'true') {
      productAvailable = true;
    } else if (product.available === 'false') {
      productAvailable = false;
    }

    // Boost SD's own native sold-out label is the strongest signal: if Boost
    // decided to render .boost-sd__product-label--soldout, the product is sold
    // out regardless of any stale availability flag in the data-product JSON.
    var boostSaysSoldOut = hasBoostSoldOutLabel(node);

    var isAvailable;
    if (boostSaysSoldOut) {
      isAvailable = false;
    } else if (badgeAvailable !== null) {
      isAvailable = badgeAvailable;
    } else if (productAvailable !== null) {
      isAvailable = productAvailable;
    } else if (sawVariantAvailability) {
      isAvailable = anyVariantAvailable;
    } else {
      // No availability signal at all yet (e.g. search page before the
      // product-data fetch resolves). Assume available to avoid flashing a
      // false "Sold Out"; the sticker is re-evaluated once data arrives.
      isAvailable = true;
    }
    /* ===== LATEST CHANGE — Out of Stock label fix (availability logic) END ===== */

    var stickers = [];
    var millisecondsPerDay = 86400000;
    var newWindowDays = getNewArrivalWindowDays();
    var createdAtSource = resolveCreatedAtSource(product);
    if ((!createdAtSource || createdAtSource === null || createdAtSource === '') && badgeData) {
      createdAtSource = badgeData.created_at || badgeData.published_at || createdAtSource;
    }
    var createdAt = parsePublishedDate(createdAtSource);
    var productAgeDays = createdAt && !isNaN(createdAt.getTime()) ? (Date.now() - createdAt.getTime()) / millisecondsPerDay : null;
    var isNewByDate = productAgeDays !== null && productAgeDays <= newWindowDays;

    if (isNewByDate) {
      stickers.push('<div class="new-sticker thumbnail-sticker"><span class="sticker-text">' + getStickerText('new_sticker', 'New') + '</span></div>');
    }

    var mappedCollections = [
      { handle: 'best-sellers', className: 'best-seller-sticker', key: 'best_seller', fallback: 'Best Seller' },
      { handle: 'coming-soon', className: 'coming-soon-sticker', key: 'coming_soon', fallback: 'Coming Soon' },
      { handle: 'backorder', className: 'backorder-sticker', key: 'backorder', fallback: 'On Backorder' },
      { handle: 'pre-order', className: 'pre-order-sticker', key: 'pre_order', fallback: 'Pre-Order' },
      { handle: 'staff-pick', className: 'staff-pick-sticker', key: 'staff_pick', fallback: 'Staff Pick' },
      { handle: 'online-exclusive', className: 'online-exclusive-sticker', key: 'online_exclusive', fallback: 'Online Exclusive' },
      { handle: 'back-in-stock', className: 'back-in-stock-sticker', key: 'back_in_stock', fallback: 'Back In Stock' }
    ];

    mappedCollections.forEach(function(map) {
      if (hasHandle(map.handle)) {
        stickers.push('<div class="' + map.className + ' thumbnail-sticker"><span class="sticker-text">' + getStickerText(map.key, map.fallback) + '</span></div>');
      }
    });

    var trackedInventoryTotal = 0;
    var inventorySource = 'none';

    for (var invIndex = 0; invIndex < variants.length; invIndex += 1) {
      var invVariant = variants[invIndex];
      var variantInventory = typeof invVariant.inventory_quantity === 'number'
        ? invVariant.inventory_quantity
        : parseInt(invVariant.inventory_quantity, 10);
      if (!isNaN(variantInventory)) {
        trackedInventoryTotal += variantInventory;
        inventorySource = 'variants';
      }
    }
    if (trackedInventoryTotal === 0 && typeof product.inventory_quantity !== 'undefined') {
      var productInventoryQuantity = typeof product.inventory_quantity === 'number'
        ? product.inventory_quantity
        : parseInt(product.inventory_quantity, 10);
      if (!isNaN(productInventoryQuantity)) {
        trackedInventoryTotal = productInventoryQuantity;
        inventorySource = 'product.inventory_quantity';
      }
    }
    if (trackedInventoryTotal === 0 && typeof product.total_inventory !== 'undefined') {
      var totalInventoryQuantity = typeof product.total_inventory === 'number'
        ? product.total_inventory
        : parseInt(product.total_inventory, 10);
      if (!isNaN(totalInventoryQuantity)) {
        trackedInventoryTotal = totalInventoryQuantity;
        inventorySource = 'product.total_inventory';
      }
    }
    // Use badgeData inventory if we don't have valid inventory from variants/product
    if (trackedInventoryTotal === 0 && badgeData && badgeData.total_inventory !== null && typeof badgeData.total_inventory !== 'undefined') {
      var badgeInventory = typeof badgeData.total_inventory === 'number'
        ? badgeData.total_inventory
        : parseInt(badgeData.total_inventory, 10);
      if (!isNaN(badgeInventory)) {
        trackedInventoryTotal = badgeInventory;
        inventorySource = 'badgeData';
      }
    }

    // If we still have no inventory data (null from failed fetch), log it
    if (inventorySource === 'none' && badgeData && badgeData.total_inventory === null) {
      console.warn('[BadgeData] No inventory data available for', product.handle, '- product may be outside embedded data limit (250)');
    }
    var almostGoneThreshold = getAlmostGoneThreshold();
    var almostGone = isAvailable && trackedInventoryTotal > 0 && trackedInventoryTotal <= almostGoneThreshold;

    // Debug logging for Almost Gone evaluation
    if (product && product.handle) {
      var shouldBeAlmostGone = badgeData && badgeData.available && badgeData.total_inventory > 0 && badgeData.total_inventory <= almostGoneThreshold;
      if (!almostGone && shouldBeAlmostGone) {
        console.warn('[BadgeData] Almost Gone MISMATCH for', product.handle, {
          expectedFromBadgeData: true,
          actualResult: almostGone,
          isAvailable: isAvailable,
          trackedInventoryTotal: trackedInventoryTotal,
          badgeDataInventory: badgeData ? badgeData.total_inventory : 'N/A',
          inventorySource: inventorySource
        });
      }
      console.debug('[BadgeData] Almost Gone check for', product.handle, {
        isAvailable: isAvailable,
        trackedInventoryTotal: trackedInventoryTotal,
        almostGoneThreshold: almostGoneThreshold,
        inventorySource: inventorySource,
        almostGone: almostGone,
        badgeData: badgeData
      });
    }

    if (almostGone) {
      stickers.push('<div class="almost-gone-sticker thumbnail-sticker"><span class="sticker-text">' + getStickerText('almost_gone', 'Almost Gone') + '</span></div>');
    }

    var priceMin = parseFloat(product && product.priceMin ? product.priceMin : 0);
    var compareAtPriceMax = parseFloat(product && product.compareAtPriceMax ? product.compareAtPriceMax : 0);
    if (isAvailable && compareAtPriceMax > priceMin && priceMin > 0) {
      stickers.push('<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + getStickerText('sale', 'Sale') + '</span></div>');
    /* ===== LATEST CHANGE — Out of Stock label fix (render visible sticker) START ===== */
    } else if (!isAvailable) {
      // Render our own visible theme sticker in the sticker-holder. Boost's
      // native --soldout label is positioned behind the product image and is
      // hidden via CSS (see boost-sd-custom.css), so we no longer defer to it.
      stickers.push('<div class="sold-out-sticker thumbnail-sticker"><span class="sticker-text">' + getStickerText('sold_out', 'Sold Out') + '</span></div>');
    }
    /* ===== LATEST CHANGE — Out of Stock label fix (render visible sticker) END ===== */

    if (!stickers.length) {
      return '';
    }
    var settings = getThemeSettings();
    var shape = settings.sticker_shape || 'square';
    var position = settings.sticker_position || 'left';
    return '<div class="sticker-holder sticker-shape-' + shape + ' sticker-position-' + position + '" ' + THEME_STICKER_ATTRIBUTE + '="true"><div class="sticker-holder__content sticker-holder__content--product">' + stickers.join('') + '</div></div>';
  }

  function applyStickerToNode(node) {
    if (!node || node.nodeType !== 1 || !isStickersEnabled()) {
      return;
    }
    var imageWrapper = findImageWrapper(node);
    if (!imageWrapper) {
      return;
    }
    var product = parseProductData(node);
    if (!product) {
      return;
    }
    var stickerMarkup = buildStickerMarkup(product, node);
    var existing = imageWrapper.querySelector('.sticker-holder[' + THEME_STICKER_ATTRIBUTE + '="true"]');
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
    node.classList.remove('has-thumbnail-sticker');
    imageWrapper.classList.remove('has-thumbnail-sticker');
    if (stickerMarkup) {
      imageWrapper.insertAdjacentHTML('afterbegin', stickerMarkup);
      node.classList.add('has-thumbnail-sticker');
      imageWrapper.classList.add('has-thumbnail-sticker');
    }
  }

  function findImageWrapper(node) {
    if (!node || !node.querySelector) {
      return null;
    }
    for (var i = 0; i < IMAGE_WRAPPER_SELECTORS.length; i += 1) {
      var wrapper = node.querySelector(IMAGE_WRAPPER_SELECTORS[i]);
      if (wrapper) {
        return wrapper;
      }
    }
    var image = node.querySelector('.boost-sd__product-image');
    if (image && image.parentNode) {
      return image.parentNode;
    }
    return null;
  }

  function collectProductNodes(scope) {
    var nodes = [];
    if (!scope) {
      return nodes;
    }
    if (matchesSelector(scope, PRODUCT_ITEM_SELECTOR)) {
      nodes.push(scope);
    }
    if (scope.querySelectorAll) {
      var found = scope.querySelectorAll(PRODUCT_ITEM_SELECTOR);
      if (found && found.length) {
        for (var i = 0; i < found.length; i += 1) {
          nodes.push(found[i]);
        }
      }
    }
    return nodes;
  }

  function scanForProductItems(root) {
    if (!isStickersEnabled()) {
      return;
    }
    var scope = root || document;
    var nodes = collectProductNodes(scope);
    if (!nodes.length && scope === document && document.querySelectorAll) {
      nodes = Array.prototype.slice.call(document.querySelectorAll(PRODUCT_ITEM_SELECTOR));
    }
    if (nodes && nodes.length) {
      for (var i = 0; i < nodes.length; i += 1) {
        applyStickerToNode(nodes[i]);
      }
    }
  }

  function processNewProductNodes(productNodes) {
    if (!productNodes || !productNodes.length) {
      return;
    }

    // Check which products need data fetched
    var nodesToFetch = [];
    var nodesToApply = [];

    for (var k = 0; k < productNodes.length; k += 1) {
      var node = productNodes[k];
      var product = parseProductData(node);
      if (product && product.handle) {
        var cachedData = getBadgeDataByHandle(product.handle);
        if (cachedData) {
          // We have data, apply immediately
          nodesToApply.push(node);
        } else {
          // Need to fetch data - log this as it may explain missing stickers
          console.warn('[BadgeData] Product NOT in embedded data, will fetch:', product.handle);
          nodesToFetch.push(node);
        }
      } else {
        // No handle, just try to apply
        nodesToApply.push(node);
      }
    }

    // Apply stickers immediately for products with cached data
    for (var i = 0; i < nodesToApply.length; i++) {
      applyStickerToNode(nodesToApply[i]);
    }

    // Fetch data for products without cached data, then apply
    if (nodesToFetch.length > 0) {
      prefetchBadgeDataForNodes(nodesToFetch).then(function() {
        for (var j = 0; j < nodesToFetch.length; j++) {
          applyStickerToNode(nodesToFetch[j]);
        }
      }).catch(function() {
        // Apply anyway even if fetch failed
        for (var j = 0; j < nodesToFetch.length; j++) {
          applyStickerToNode(nodesToFetch[j]);
        }
      });
    }
  }

  function startStickerObserver() {
    if (!isStickersEnabled() || typeof MutationObserver === 'undefined') {
      return;
    }
    var pendingNodes = [];
    var debounceTimer = null;

    var processPendingNodes = function() {
      if (pendingNodes.length) {
        var nodes = pendingNodes.slice(0);
        pendingNodes = [];
        processNewProductNodes(nodes);
      }
    };

    var observer = new MutationObserver(function(mutations) {
      var foundNodes = [];
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) {
          for (var j = 0; j < mutation.addedNodes.length; j += 1) {
            var node = mutation.addedNodes[j];
            if (node.nodeType !== 1) {
              continue;
            }
            var productNodes = collectProductNodes(node);
            if (productNodes.length) {
              for (var k = 0; k < productNodes.length; k += 1) {
                foundNodes.push(productNodes[k]);
              }
            }
          }
        }
      }

      if (foundNodes.length) {
        for (var n = 0; n < foundNodes.length; n += 1) {
          if (pendingNodes.indexOf(foundNodes[n]) === -1) {
            pendingNodes.push(foundNodes[n]);
          }
        }
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }
        debounceTimer = setTimeout(processPendingNodes, 10);
      }
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }


  // SVG heart icon matching the Swym wishlist button used by Boost SD SSR
  var SWYM_HEART_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1336 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.0064 7.3536 1.93063 10.7436 3.9836 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 22.0006 7.3636 19.6706 5.4736Z" stroke="#000000" stroke-width="1.7px" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  // Attach click handler that calls Swym API directly
  function attachSwymClickHandler(button, productId, productUrl, productData) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!window._swat) return;

      var self = this;
      var isWishlisted = self.getAttribute('aria-pressed') === 'true';

      // Parse variant ID — Boost SD stores variants as JSON string or array
      var variants = productData.variants || [];
      if (typeof variants === 'string') {
        try { variants = JSON.parse(variants); } catch (ex) { variants = []; }
      }
      var firstVariant = Array.isArray(variants) && variants.length ? variants[0] : {};
      var epi = firstVariant.id ? parseInt(String(firstVariant.id), 10) : parseInt(productId, 10);

      function doSwymAction(variantId, freshData) {
        var obj = {
          empi: parseInt(productId, 10),
          epi: variantId,
          du: productUrl,
          dt: (freshData && freshData.title) || productData.title || '',
          pr: (freshData && freshData.price) ? freshData.price / 100 : (productData.priceMin || 0) / 100,
          iu: (freshData && freshData.featured_image) || (productData.images && productData.images[0] && productData.images[0].src) || ''
        };
        if (isWishlisted) {
          _swat.removeFromWishList(obj, function() {
            self.setAttribute('aria-pressed', 'false');
            self.setAttribute('aria-label', 'Add to wishlist');
          }, function() {});
        } else {
          _swat.addToWishList(obj, function() {
            self.setAttribute('aria-pressed', 'true');
            self.setAttribute('aria-label', 'Added. View Wishlist');
          }, function() {});
        }
      }

      // If variant ID lookup failed (epi === productId), fetch fresh from Shopify product JSON
      if (epi === parseInt(productId, 10) && productData.handle) {
        fetch('/products/' + productData.handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(p) {
            var vid = p.variants && p.variants.length ? parseInt(p.variants[0].id, 10) : epi;
            doSwymAction(vid, p);
          })
          .catch(function() { doSwymAction(epi, null); });
      } else {
        doSwymAction(epi, null);
      }
    });
  }

  // Check if product is already in wishlist and update button state
  function syncSwymWishlistState(button, productId) {
    if (!window._swat) return;
    _swat.fetch(function(lists) {
      try {
        var allItems = [];
        if (lists && lists.length) {
          lists.forEach(function(list) {
            if (list.listcontents) allItems = allItems.concat(list.listcontents);
          });
        }
        var inWishlist = allItems.some(function(item) {
          return String(item.empi) === String(productId);
        });
        button.setAttribute('aria-pressed', inWishlist ? 'true' : 'false');
      } catch(e) {}
    });
  }

  // Inject Swym wishlist button HTML into newly loaded products that are missing it
  // Only processes the specific nodes passed in (avoids doubling SSR products)
  function injectSwymWishlistButtons(productNodes) {
    if (!productNodes || !productNodes.length) return;

    for (var i = 0; i < productNodes.length; i++) {
      var item = productNodes[i];
      if (item.querySelector('.swym-wishlist-collections-v2-container')) continue;

      var productId = item.getAttribute('data-product-id');
      if (!productId) continue;

      var productData = {};
      try { productData = JSON.parse(item.getAttribute('data-product') || '{}'); } catch (e) {}

      var productUrl = window.location.origin + '/products/' + (productData.handle || productId);

      // Register product data into SwymProductVariants so Swym's own re-initialization
      // (triggered when the wishlist sidebar opens) can correctly restore the heart state
      var variants = productData.variants || [];
      if (typeof variants === 'string') { try { variants = JSON.parse(variants); } catch(e) { variants = []; } }
      var firstVariant = Array.isArray(variants) && variants.length ? variants[0] : {};
      var variantId = firstVariant.id ? parseInt(String(firstVariant.id), 10) : parseInt(productId, 10);
      var imageUrl = (productData.images && productData.images[0] && productData.images[0].src) ? productData.images[0].src : '';
      var price = (productData.priceMin || 0) / 100;

      window.SwymProductVariants = window.SwymProductVariants || {};
      window.SwymProductVariants[variantId] = {
        empi: parseInt(productId, 10),
        epi: variantId,
        du: productUrl,
        dt: productData.title || '',
        ct: productData.productType || '',
        iu: imageUrl,
        pr: price,
        variants: [{ 'Default': variantId }]
      };

      // Build fresh button HTML — exact same structure as Boost SD SSR output
      var container = document.createElement('div');
      container.className = 'swym-wishlist-collections-v2-container boost-sd-swym-injected';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'swym-wishlist-collections-v2';
      button.setAttribute('data-product-id', productId);
      button.setAttribute('href', productUrl);
      button.setAttribute('aria-label', 'Add to wishlist');
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = SWYM_HEART_SVG;

      attachSwymClickHandler(button, productId, productUrl, productData);
      syncSwymWishlistState(button, productId);

      container.appendChild(button);

      // Insert inside the div[style="position:relative"] that Boost SD SSR uses —
      // this is the direct parent of .boost-sd__product-image-wrapper
      var imageWrapper = item.querySelector('.boost-sd__product-image-wrapper');
      var relativeParent = imageWrapper ? imageWrapper.parentNode : null;
      if (relativeParent && window.getComputedStyle(relativeParent).position !== 'static') {
        relativeParent.appendChild(container);
      } else {
        // Fallback: insert into link-image div and force position:relative
        var linkImage = item.querySelector('.boost-sd__product-link-image') || item;
        if (window.getComputedStyle(linkImage).position === 'static') {
          linkImage.style.position = 'relative';
        }
        linkImage.appendChild(container);
      }
    }
  }

  // Watch for new Boost SD product items added via infinite scroll and re-init Swym wishlist buttons
  function startSwymObserver() {
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    var swymTimer = null;
    var pendingProductNodes = [];

    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type !== 'childList' || !mutation.addedNodes.length) continue;
        for (var j = 0; j < mutation.addedNodes.length; j += 1) {
          var node = mutation.addedNodes[j];
          if (node.nodeType !== 1) continue;
          // Collect only new product item nodes (direct or nested)
          if (node.classList && node.classList.contains('boost-sd__product-item')) {
            if (pendingProductNodes.indexOf(node) === -1) pendingProductNodes.push(node);
          } else if (node.querySelector) {
            var nested = node.querySelectorAll('.boost-sd__product-item');
            for (var k = 0; k < nested.length; k++) {
              if (pendingProductNodes.indexOf(nested[k]) === -1) pendingProductNodes.push(nested[k]);
            }
          }
        }
      }

      if (pendingProductNodes.length) {
        if (swymTimer) clearTimeout(swymTimer);
        swymTimer = setTimeout(function() {
          var nodesToProcess = pendingProductNodes.slice(0);
          pendingProductNodes = [];
          // Always defer until _swat is ready so Swym injects first.
          // This prevents the double-heart race condition on fresh browsers
          // where our 300ms fires before Swym JS has loaded and initialised.
          if (window._swat) {
            injectSwymWishlistButtons(nodesToProcess);
            setTimeout(deduplicateSwymButtons, 600);
          } else {
            window.SwymCallbacks = window.SwymCallbacks || [];
            window.SwymCallbacks.push(function() {
              injectSwymWishlistButtons(nodesToProcess);
              setTimeout(deduplicateSwymButtons, 600);
            });
          }
        }, 300);
      }

    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  // Belt-and-suspenders: remove any duplicate wishlist buttons that slipped through
  function deduplicateSwymButtons() {
    var items = document.querySelectorAll('.boost-sd__product-item');
    for (var i = 0; i < items.length; i++) {
      var containers = items[i].querySelectorAll('.swym-wishlist-collections-v2-container');
      for (var j = 1; j < containers.length; j++) {
        containers[j].parentNode.removeChild(containers[j]);
      }
    }
  }

  // Inject icon-only Swym wishlist button on product pages (top-right of product image)
  function injectProductPageWishlistButton() {
    var placeholder = document.querySelector('.product-image-swym-placeholder');
    if (!placeholder) return;
    // Already injected
    if (placeholder.querySelector('.swym-wishlist-collections-v2-container')) return;

    var pageData = window.SwymPageData;
    if (!pageData || !pageData.empi) return;

    var productId = String(pageData.empi);
    var productUrl = pageData.du || window.location.href;

    var container = document.createElement('div');
    container.className = 'swym-wishlist-collections-v2-container boost-sd-swym-injected';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'swym-wishlist-collections-v2';
    button.setAttribute('data-product-id', productId);
    button.setAttribute('href', productUrl);
    button.setAttribute('aria-label', 'Add to wishlist');
    button.setAttribute('aria-pressed', 'false');
    button.innerHTML = SWYM_HEART_SVG;

    button.addEventListener('click', function(e) {
      e.preventDefault();
      if (!window._swat) return;
      var self = this;
      var isWishlisted = self.getAttribute('aria-pressed') === 'true';
      // Always read current variant from SwymPageData (updates on variant change)
      var currentData = window.SwymPageData || pageData;
      var obj = {
        empi: parseInt(productId, 10),
        epi: currentData.epi || pageData.epi,
        du: currentData.du || productUrl,
        dt: currentData.dt || pageData.dt || '',
        pr: currentData.pr || pageData.pr || 0,
        iu: currentData.iu || pageData.iu || ''
      };
      if (isWishlisted) {
        _swat.removeFromWishList(obj, function() {
          self.setAttribute('aria-pressed', 'false');
          self.setAttribute('aria-label', 'Add to wishlist');
        }, function() {});
      } else {
        _swat.addToWishList(obj, function() {
          self.setAttribute('aria-pressed', 'true');
          self.setAttribute('aria-label', 'Added. View Wishlist');
        }, function() {});
      }
    });

    syncSwymWishlistState(button, productId);
    container.appendChild(button);
    placeholder.appendChild(container);

    // Re-sync heart state when variant changes
    document.addEventListener('variantChanged', function() {
      syncSwymWishlistState(button, productId);
    });
  }

  // Hide Swym's auto-injected near-cart button on product pages (we handle it ourselves)
  function hideAutoSwymProductButton() {
    var style = document.createElement('style');
    style.textContent = '.product__information .swym-btn-container, .product-block--form .swym-btn-container { display: none !important; }';
    document.head.appendChild(style);
  }

  onReady(function() {
    scanForSearchInputs(document);
    startSearchInputObserver();
    bindGlobalEvents();
    evaluateScrollLock();
    startScrollObserver();

    // Load embedded inventory data from Liquid (if available on collection pages)
    // This must happen before applying stickers
    loadEmbeddedInventoryData();

    // Start observing for new product nodes immediately
    startStickerObserver();

    // Watch for new products loaded via infinite scroll and re-init Swym wishlist buttons
    startSwymObserver();

    // Deduplicate any hearts left over from Swym auto-injection + our custom injection on initial load
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function() {
      setTimeout(deduplicateSwymButtons, 600);
    });

    // Apply stickers to any products already on the page
    var initialNodes = collectProductNodes(document);
    if (initialNodes.length > 0) {
      processNewProductNodes(initialNodes);
    }

    // Product page: inject icon-only heart button after Swym loads
    if (document.querySelector('.product-image-swym-placeholder')) {
      hideAutoSwymProductButton();
      if (window._swat) {
        injectProductPageWishlistButton();
      } else {
        window.SwymCallbacks = window.SwymCallbacks || [];
        window.SwymCallbacks.push(function() {
          injectProductPageWishlistButton();
        });
      }
    }

  });
})();
